import { render, staticRenderFns } from "./FileMetadata.vue?vue&type=template&id=19acc240"
import script from "./FileMetadata.vue?vue&type=script&lang=ts"
export * from "./FileMetadata.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports